import { getCvAccessToken } from '@carvana/core-auth';
import { isClient } from '../is-client';

// APIK (Kong) exchanges the opaque phantom token in Authorization for a verified JWT before it reaches the API.
export const getAuthHeaders = () => {
  if (!isClient()) return {};

  const accessToken = getCvAccessToken();

  return accessToken ? { Authorization: `Bearer ${accessToken}` } : {};
};
